import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import gradient from "../../Assets/gradient-hero-light.png";
import { Link } from "react-router";
import ContactBlock from "../ContactBlock";
import ServicesCard from "../../components/ServicesCard"
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

import s1 from "../../Assets/services/1.png";
import s2 from "../../Assets/services/2.png";
import s3 from "../../Assets/services/3.png";

export default function Service() {
    return (
        <div>
            <section className='bg-theme section-hero'>
                <Container fluid className="header-section">
                    <Row>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1 text-white">Enterprise Software Solutions</h1>
                                </div>
                                <div className='pt-2 max-width-large mx-auto'>
                                    <p className="text-size-medium">At Parabola IT Development, we specialize in architecting enterprise-grade solutions tailored to unique operational requirements. From ERP systems and CRM integrations to data analytics platforms and workflow automation, our enterprise software is built to drive efficiency, agility, and growth—while maintaining compliance and security at every level.</p>
                                </div>
                                <div className="pt-3 d-flex justify-content-center">
                                    <Link to="/contact" className="btn btn-dark rounded-pill px-5 py-3">Get In Touch</Link>
                                </div>
                            </div>
                        </Col>
                        <div className="pills-wrap">
                            <div className="hero-pill-left-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                            <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                        </div>
                    </Row>
                </Container >
            </section >
            <section className='bg-white px-0 px-md-5 pb-0 padding-section-large'>
                <div className='p-5 rounded-24 bg-grey'>
                    <h1 className='display-5 main-name text-center'>Case Study</h1>
                    <h4 className='py-3 text-center'>MLM Software Engineering Expertise for Enterprise Systems</h4>
                    <p className='text-size-medium py-3 text-center'>At Parabola IT Development, we provide experienced engineering teams with deep expertise in building, integrating, and maintaining complex MLM (Multi-Level Marketing) software platforms. Our engineers have worked extensively with leading MLM systems and enterprise clients to design scalable, secure, and fully customized solutions.</p>
                    <h4 className='display-6 text-center pb-3'>Our Capabilities Include</h4>
                    <div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Building and maintaining enrollment flows, genealogy management, and rep portals</p>
                    </div>
                    <div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Implementing and optimizing compensation plans, autoship, and bonus logic</p>
                    </div>
                    <div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Developing custom integrations with backend systems like Exigo, Infotrax, and ByDesign</p>
                    </div><div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Integrating and managing payment gateways (e.g., Stripe, Propay, Authorize.Net) and fraud detection tools like Kount Connecting with tax and address verification systems such as Avalara etc</p>
                    </div>
                    <div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Designing and supporting rep engagement tools: eCards, email campaigns, personal websites, and mobile back offices</p>
                    </div>
                    <div className='d-flex flex-row mb-2 align-items-center'>
                        <div className='iconBlock me-3'>
                            <i class="fi fi-ts-check-circle main-name fs-1"></i>
                        </div>
                        <p>Building analytics dashboards, downline reports, alerts, and scalable data pipelines</p>
                    </div>
                    <p className='text-size-medium py-3 text-center main-name'>Our teams work as an extension of your in-house capabilities—whether you’re launching a new platform, modernizing legacy systems, or need hands-on support for an existing MLM infrastructure.</p>

                    <Carousel>
                        <Carousel.Item>
                            <Image src={s1} className='img-fluid' />
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={s2} className='img-fluid' />
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={s3} className='img-fluid' />
                        </Carousel.Item>
                    </Carousel>
                </div>
            </section >
            <ServicesCard />
            <ContactBlock />
        </div >
    )
}
